<div tabindex="0" id="tools"  class="d-flex flex-wrap" style="gap:16px; width: 410px; padding: 24px;">

    <div class="tool-box d-flex flex-column align-items-center justify-content-center"
        *ngFor="let widget of data.tools.widgets" (click)="addWidget(widget)">

        <div>
            <mat-icon class="material-icons-outlined">{{widget?.icon()}}</mat-icon>
        </div>
        <div>{{widget?.name()}}</div>

    </div>

    <div class="tool-box d-flex flex-column align-items-center justify-content-center"
        *ngFor="let widget of data.layoutTools" (click)="addWidget(widget)">
    
        <div>
            <mat-icon class="material-icons-outlined">{{widget?.icon()}}</mat-icon>
        </div>
        <div>{{widget?.name()}}</div>

    </div>

</div>